import 'ui-core/widgets/article-tools/js/article-tools';

(function () {
    UX.articleTools.displayClippingTool = function () {
        let useclippingtool = $('.switch-player').attr('useclippingtool');

        if ($('.article-tool__clipping').length && useclippingtool === 'true') {
            $('.article-tool__clipping').show();
        }
    };

    UX.articleTools.copyLink = function () {
        const embedLink = document.querySelectorAll('.embedLink');
        embedLink.forEach(el => {
            const url = el.getAttribute('data-url');
            const doi = $('.video__content')?.data('doi') || '';
            el.addEventListener('click', () => {
                UX.articleTools.copy(url, `&sourcePub=${doi}`, 'embedIframe');
            });
        });
    };

    if ($('.switch-player').length) {
        UX.articleTools.displayClippingTool();
    }

    if ($('.embedLink').length) {
        UX.articleTools.copyLink();
    }

    UX.articleTools.copy = function (str, additionalLink = '', type = '') {
        const el = document.createElement('textarea');
        var copiedEvent;
        el.id = 'temp_element';
        if (type === 'embedIframe') {
            el.value =
                '<iframe allowfullscreen="true" width="720" height="480" src="' +
                document.location.protocol +
                '//' +
                document.location.host +
                str +
                additionalLink +
                '"></iframe>';
        } else {
            el.value = document.location.protocol + '//' + document.location.host + additionalLink + str;
        }
        el.setAttribute('readonly', '');
        document.body.appendChild(el);

        /*to work on IOS*/
        let selector = document.querySelector('#temp_element');
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            selector.setSelectionRange(0, 999999);
        } else {
            selector.select();
        }

        document.execCommand('copy');
        document.body.removeChild(el);

        // to show alert message that the text is copied, implemented on RMIT
        copiedEvent = $.Event('link:copied');
        $(document).trigger(copiedEvent, [UX.articleTools]);
        if (copiedEvent.isDefaultPrevented()) {
            return;
        }
    };
    $(document).on('link:copied', function () {
        let $notification = `<p class="alert-msg alert-msg--success">
                    <i class="icon-checkmark"></i>Text copied into clipboard.
                    </p>`;

        $('.actions-block-container').append($notification);

        setTimeout(function () {
            $('.actions-block-container .alert-msg').remove();
        }, 3000);
    });
})();
